<template>
  <div class="setting row">
    <!-- settings for test and pretest  -->
    <!-- <div class="pr"> -->
    <!-- <router-link :to="{ name: 'studentProfile' }" class="view-perfile">{{
      $t('sidebar.viewProfile')
    }}</router-link> -->
    <div class="setting-item effect" @click="go('/manage-content-by-grade')">
      <div class="setting-item-title">
        <h5 class="title">{{ $t('settings.study') }}</h5>
        <img src="@/assets/settings/study.png" />
      </div>
      <div class="setting-item-content">
        <p class="description">{{ $t('settings.theBestWayChildrenFocus') }}</p>
        <!-- <button @click="go('/tutor/manage-content-by-grade')" type="button" class="btn btn-light go-setting">{{ $t('testBooks.settings') }}</button> -->
      </div>
    </div>
    <!-- </div> -->
    <!-- #settings for test and pretest  -->
    <!-- evaluation section by student -->
    <div class="setting-item effect" @click="go('/evaluation')">
      <div class="setting-item-title">
        <div class="title2">
          <h5 class="title">{{ $t('settings.applayEvaluation') }}</h5>
        </div>
        <img src="@/assets/settings/question-list.png" />
      </div>
      <div class="setting-item-content">
        <p class="description">{{ $t('settings.testMeasure') }}</p>
        <!-- <button @click="go('/tutor/evaluation')" type="button" class="btn btn-light go-setting">{{ $t('testBooks.settings') }}</button> -->
      </div>
    </div>

    <!-- #evaluation section by student -->

    <!-- bilingual section by student -->
    <div class="setting-item effect" @click="toggleWorksheets">
      <div class="setting-item-title">
        <h5 class="title">{{ $t('settings.worksheets') }}</h5>
        <!-- <img src="./src/renderer/assets/settings/worksheets.png"> -->
        <img src="@/assets/settings/worksheets.png" />
      </div>
      <div class="setting-item-content">
        <p class="description">
          {{ $t('settings.worksheetDescription') }}
          <!-- Lorem ipsum dolor sit amet consectetur adipisicing elit. Neque soluta ipsam eveniet est enim aut at architecto dolorem ex, ducimus temporibus quis corporis necessitatibus incidunt iste maxime nostrum accusantium dolor! -->
          <!-- <language-selector></language-selector> -->
        </p>
        <!-- <button @click="go('/tutor/evaluation')" type="button" class="btn btn-light go-setting">Setting</button> -->
      </div>
    </div>
    <tpm-modal :showhide="showWorksheets">
      <div class="modal-header my-class">
        <!-- title start -->
         <img src="@/assets/icons/menu/windows_control/Close_1.svg" @click="toggleWorksheets" alt />
        <h5 class="">{{ $t('settings.worksheets') }}</h5>
        <!-- #title end -->
        <!-- <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="toggleWorksheets">
          <img src="@/assets/icons/Asset 37.png" alt />
        </button> -->
      </div>
      <div class="modal-body worksheet-modal-body">
        <!-- content start -->
        <div class="row modal-body-custom">
          <div class="col-12 col-sm-6 mb-3">
            <label class="worksheet-selector" for="grades">{{ $t('worksheets.selectGrade') }}</label>
            <div class="select-container">
              <select
                id="grades"
                v-model="selectGrade"
                class="form-control text-capitalize select-style"
                @change="handleChangeGrades"
              >
                <option disabled :value="undefined" selected>{{ $t('manageContentByGrade.pleaseSelectOne') }}</option>
                <option v-for="grade in grades" :key="grade.id" class :data-gradepath="grade.path">{{
                  grade.name
                }}</option>
              </select>
              <img src="@/assets/icons/chevronDown.png" alt />
            </div>
          </div>
          <div class="col-12 col-sm-6">
            <label class="worksheet-selector" for="subjects">{{ $t('worksheets.selectSubject') }}</label>
            <div class="select-container">
              <select
                id="subjects"
                class="form-control text-capitalize select-style"
                :disabled="!enableSubjects"
                @change="getWorksheets"
              >
                <option :value="undefined" selected>{{ $t('manageContentByGrade.pleaseSelectOne') }}</option>
                <option v-for="subject in subjects" :key="subject.id" :data-subjectid="subject.id">{{
                  subject.name | deleteNumbers
                }}</option>
              </select>
              <img src="@/assets/icons/chevronDown.png" alt />
            </div>
          </div>
          <div class="col-12">
            <!-- <div v-if="pdfPath" class="pdf"> -->
            <!-- <div class="closepdf" @click="closePDF">X</div> -->
            <!-- <pdf src="http://localhost:9080/src/renderer/assets/worksheets/21_answer.pdf"></pdf> -->
            <!-- </div> -->
            <div class="worksheets">
              <template v-if="worksheets">
                <div v-for="cluster in worksheets" :key="cluster.name" class="cluster-worksheet">
                  <h4>{{ $t('worksheets.cluster') }}: {{ cluster.name }}</h4>
                  <div class="lesson-headings">
                    <span class="lesson">{{ $t('worksheets.lesson') }}</span>
                    <span class="id">{{ $t('worksheets.lessonid') }}</span>
                    <span class="worksheet">{{ $t('worksheets.worksheet') }}</span>
                    <span class="answers">{{ $t('worksheets.answer') }}</span>
                  </div>
                  <div v-for="lesson in cluster.lessons" :key="lesson.id" class="lesson-worksheet">
                    <span class="lesson">{{ lesson.name }}</span>
                    <span class="id">{{ lesson.id }}</span>
                    <span v-if="lesson.questions" class="worksheet">
                      <!-- <span @click="viewPDF(lesson.questions)"><i class="fa fa-eye" aria-hidden="true"></i>{{ $t('worksheets.view') }}</span> -->
                      <!-- <a :href="lesson.questions" target="_blank" rel="noreferrer"><img src="@/assets/icons/download_icon_blue.png" alt="">{{ $t('worksheets.download') }}</a> -->
                      <a :href="lesson.questions" target="_blank" rel="noreferrer">
                        <i class="fa fa-eye" aria-hidden="true"></i>
                        {{ $t('worksheets.view') }}
                      </a>
                    </span>
                    <span v-else class="worksheet na">{{ $t('worksheets.na') }}</span>
                    <span v-if="lesson.answers" class="answers">
                      <!-- <span @click="viewPDF(lesson.answers)"><i class="fa fa-eye" aria-hidden="true"></i>{{ $t('worksheets.view') }}</span> -->
                      <!-- <span @click="viewPDF(lesson.answers)" :href="lesson.answers"><img src="@/assets/icons/download_icon_blue.png" alt="">{{ $t('worksheets.download') }}</span> -->
                      <!-- <a :href="lesson.answers"><img src="@/assets/icons/download_icon_blue.png" alt="">{{ $t('worksheets.download') }}</a> -->
                      <a :href="lesson.answers" target="_blank" rel="noreferrer">
                        <i class="fa fa-eye" aria-hidden="true"></i>
                        {{ $t('worksheets.view') }}
                      </a>
                    </span>
                    <span v-else class="answers na">{{ $t('worksheets.na') }}</span>
                    <!-- <span v-if="lesson.answers" class="answers" @click="showPDF(lesson.answers)"><img src="@/assets/icons/view_icon_blue.png" alt="">{{ $t('worksheets.view') }}</span>
                  <span v-else class="answers na">{{ $t('worksheets.na') }}</span>-->
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
        <!-- #content end -->
        <!-- btn submit -->
      </div>
    </tpm-modal>
    <!-- #bilingual section by student -->

    <!-- settings for send of emails to the tutor -->
    <div class="setting-item effect" @click="getInfOfAllTutors">
      <div class="setting-item-title">
        <h5 class="title">{{ $t('testBooks.settings') }}</h5>
        <!-- <h5 class="title">{{ $t('settings.sendingReports') }}</h5> -->
        <img src="@/assets/settings/settings-gears.png" />
      </div>
      <div class="setting-item-content">
        <p class="description">{{ $t('settings.theBestWayAlwaysInformed') }}</p>
        <!-- <button @click="getInfOfAllTutors" type="button" class="btn btn-light go-setting">
          {{ $t('testBooks.settings') }}
        </button>-->
      </div>
    </div>
    <tpm-modal :showhide="showSetEmail">
      <div class="modal-header my-class">
        <!-- title start -->
        <img src="@/assets/icons/menu/windows_control/Close_1.svg" @click="showSetEmail = false" alt />
        <h5 class="modal-title text-white">{{ $t('testBooks.settings') }}</h5>
        <!-- #title end -->
        <!-- <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="showSetEmail = false">
          <span aria-hidden="true">&times;</span>
        </button> -->
      </div>
      <div class="modal-body">
        <!-- content start -->
        <div class="row modal-body-custom">
          <div class="col-md-12">
            <div class="form-group" style="display: flex; justify-content: space-between; align-items: center;">
              <label>
                <strong>{{ $t('settings.statusOfSending') }}</strong>
              </label>
              <toggle-button
                v-model="statusSendingReports"
                :value="statusSendingReports"
                :sync="true"
                :speed="300"
                :labels="{
                  checked: $t('manageContentByGrade.enable'),
                  unchecked: $t('manageContentByGrade.disable'),
                }"
                :width="95"
                color="#78C25F"
              />
            </div>
          </div>
          <!-- <div class="col-md-12">
            <div class="form-group" style="display:flex; justify-content:space-between; align-items: center;">
              <label><strong>{{ $t('intro.show') }}</strong></label>
              <toggle-button :value="$store.state.intro" v-model="$store.state.intro" :sync="true" :speed="300" :labels="{checked: $t('manageContentByGrade.enable'), unchecked: $t('manageContentByGrade.disable')}" :width="95" color="#78C25F"/>
            </div>
          </div>-->
          <div class="col-md-12">
            <div class="form-group" style="display: flex; justify-content: space-between; align-items: center;">
              <label>
                <strong>{{ $t('lessonAudio.play') }}</strong>
              </label>
              <toggle-button
                v-model="$store.state.lessonAudio"
                :value="$store.state.lessonAudio"
                :sync="true"
                :speed="300"
                :labels="{
                  checked: $t('manageContentByGrade.enable'),
                  unchecked: $t('manageContentByGrade.disable'),
                }"
                :width="95"
                color="#78C25F"
              />
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group" style="display: flex; justify-content: space-between; align-items: center;">
              <LanguageSelector />
            </div>
          </div>
          <!-- <div class="col-md-12">
            <div class="form-group" style="display:flex; justify-content:space-between; align-items: center;">
              <template v-if="$store.state.language === 'en'">
                <strong>Read from:</strong>
                <div>
                  <button :class="['btn btn-sm mr-1', { 'btn-success': modeReadFrom === 'local disk' }]" @click="setModeReadFrom(0)">Hard disk</button>
                  <button :class="['btn btn-sm', { 'btn-success': modeReadFrom === 'external disk' }]" @click="setModeReadFrom(1)">External disk</button>
                </div>
              </template>
              <template v-else>
                <strong>Leer de:</strong>
                <div>
                  <button :class="['btn btn-sm mr-1', { 'btn-success': modeReadFrom === 'local disk' }]" @click="setModeReadFrom(0)">Disco duro</button>
                  <button :class="['btn btn-sm', { 'btn-success': modeReadFrom === 'external disk' }]" @click="setModeReadFrom(1)">Disco externo</button>
                </div>
              </template>
            </div>
          </div>-->
          <!-- <div class="col-md-12">
            <div class="form-group" style="display:flex; justify-content:space-between; align-items: center;">
              <template v-if="$store.state.language === 'en'">
                <strong>TPM Web:</strong>
                <button type="button" class="btn btn-secondary btn-sm" @click="navToWebRegistration">Free trial</button>
              </template>
              <template v-else>
                <strong>TPM Web</strong>
                <button type="button" class="btn btn-secondary btn-sm" @click="navToWebRegistration">Prueba gratis</button>
              </template>
            </div>
          </div>-->
        </div>
        <!-- #content end -->
        <!-- btn submit -->
        <div class="options">
          <div class="button cancel" @click="closeModalEmail">  {{ $t('singup.cancel') }}</div>
          <div class="button save" @click="saveStatusToReceiveReports"> {{ $t('singup.save') }}</div>
          <!-- <button type="button" class="btn btn-info" @click="closeModalEmail">
            {{ $t('singup.cancel') }}
          </button>
          <button class="btn btn-primary float-right" style="margin-right: 1rem;" @click="saveStatusToReceiveReports">
            {{ $t('singup.save') }}
          </button> -->
        </div>
      </div>
    </tpm-modal>
  </div>
</template>
<script>
import axios from 'axios';
import { mapGetters, mapMutations, mapActions } from 'vuex';
import _ from 'lodash';
import LanguageSelector from './components/LanguageSelector';
import swal from 'sweetalert';
// const { ipcRenderer } = require('electron')
export default {
  name: 'Settings',
  components: {
    LanguageSelector: LanguageSelector,
  },
  data() {
    return {
      emailSelected: undefined,
      showSetEmail: false,
      showWorksheets: false,
      // websockets
      wsSaveEmailSelected: '',
      // wsGetNameAndEmailOfTutorSelectToReceiveReportsFromDB: '',
      // alamacena el nombre y email de todos los tutores
      infOfTutors: [],
      // Nombre del tutor seleccionado
      nameOfTutor: '',
      statusSendingReports: false,
      // Variables para determinar la clase del toggle del 'statusSendingReports'
      isTrueSendingReports: true,
      isFalseSendingReports: false,
      payload: {
        token: this.$store.state.cookie,
      },
      grades: [],
      gradeSelected: null,
      subjects: [],
      gradePathSelected: '',
      enableSubjects: false,
      selectGrade: undefined,
      subjectIdSelected: '',
      clusterWorksheets: null,
      worksheets: [],
      selected_language: '',
      languages: [
        { value: 'es', label: this.$t('languages.es') },
        { value: 'en', label: this.$t('languages.en') },
      ],
      // worksheetPath: 'C:\\ProgramData\\The Perfect classMate\\assets\\worHud98Km\\'
      worksheetPath: 'static/worHud98Km/',
      // worksheetPath: 'http://localhost:3001/statics/worHud98Km/'
    };
  },
  computed: {
    ...mapGetters({
      getLanguage: 'language',
      modeReadFrom: 'serveLesson/modeReadFrom',
      authenticatedUser: 'auth/authenticatedUser',
    }),
  },
  watch: {
    worksheets: function (val) {
      _.forEach(val, function (cluster) {
        cluster.lessons = _.orderBy(cluster.lessons, ['id'], ['asc']);
        console.log(cluster);
      });
      // console.log(val)
      // return _.orderBy(val, ['name'],['asc']); // Use Lodash to sort array by 'name
      // val.map((cluster) => {
      //   if (cluster.lessons) {
      //     cluster.lessons.sort((a, b) => {
      //       if (a.id < b.id) return -1
      //       if (a.id > b.id) return 1
      //       return 0
      //     })
      //   }
      // })
      // console.log(this.worksheets)
    },
    //   checked: function (value) {
    //     if (value) {
    //       this.isTrueSendingReports = true
    //       this.isFalseSendingReports = false
    //       // this.statusSendingReports = 0 // true
    //     }
    //     if (!value) {
    //       this.isTrueSendingReports = false
    //       this.isFalseSendingReports = true
    //       // this.statusSendingReports = 1 // false
    //     }
    //   }
  },
  created() {
    this.fetchGrades();
    this.getStatusToReceiveReports();
  },
  methods: {
    ...mapMutations({
      showSidebar: 'showSidebar',
    }),
    ...mapActions({
      fetchUpdateMode: 'serveLesson/FETCH_UPDATE_MODE',
    }),
    setModeReadFrom(mode) {
      this.fetchUpdateMode(mode);
      // this.$store.commit('serveLesson/MODE_READ_FROM', mode)
    },
    navToWebRegistration() {
      this.showSidebar(false);
      this.go('/web-registration');
    },
    setShowIntro() {
      var ws = this;
      this.$httpMain
        .post(`set_intro`, {
          show_intro: this.$store.state.intro ? 1 : 0,
        })
        .catch(function (error) {
          if (error) {
            ws.$toasted.show(ws.$t('messages.ops'), {
              type: 'error',
              position: 'bottom-right',
              duration: 2000,
              icon: {
                name: 'times-circle',
              },
            });
          }
        });
    },
    setPlayLessonAudio() {
      var ws = this;
      this.$httpMain
        .post(`set_lesson_audio`, {
          play_lesson_audio: this.$store.state.lessonAudio ? 1 : 0,
        })
        .catch(function (error) {
          if (error) {
            ws.$toasted.show(ws.$t('messages.ops'), {
              type: 'error',
              position: 'bottom-right',
              duration: 2000,
              icon: {
                name: 'times-circle',
              },
            });
          }
        });
    },
    handleChangeEmails(e) {
      if (e.target.options.selectedIndex > -1) {
        this.nameOfTutor =
          e.target.options[e.target.options.selectedIndex].dataset.firstname +
          ' ' +
          e.target.options[e.target.options.selectedIndex].dataset.lastname;
      }
    },
    saveStatusToReceiveReports() {
      var self = this;
      this.$httpMain
        .post(`save_email_selected`, {
          tutor_id: this.authenticatedUser.id,
          status: this.statusSendingReports,
          //tutor_id: this.$store.state.userAuthenticated.id,
          //token: this.$store.state.cookie,
        })
        .then(function (res) {
          // console.log(res.data);
          if (JSON.parse(res.data) === true) {
            self.showSetEmail = false;
            swal({
              title: self.$t('messages.succes'),
              text: self.$t('sidebar.savedSatis'),
              icon: 'success',
              buttons: 'OK',
              closeOnClickOutside: false,
            });
            // self.$toasted.success(self.$t('sidebar.savedSatis'), {
            //   position: 'bottom-left',
            //   duration: 1200,
            //   icon: {
            //     name: 'check-circle',
            //   },
            // });
          }
          if (JSON.parse(res.data) === false) {
            swal({
              title: self.$t('messages.ops'),
              icon: 'error',
              buttons: 'OK',
              closeOnClickOutside: true,
            });
          }
          if (JSON.parse(res.data) === null) {
            swal({
              title: self.$t('messages.ops'),
              icon: 'error',
              buttons: 'OK',
              closeOnClickOutside: true,
            });
          }
        });
      // this.setShowIntro();
      this.setPlayLessonAudio();
    },
    getStatusToReceiveReports() {
      var self = this;
      this.$httpMain
        .post(`get_status_to_receive_reports`, {
          token: this.$store.state.cookie,
          //data: this.$store.state.userAuthenticated.id.toString(),
          data: this.authenticatedUser.id.toString(),
        })
        .then(function (res) {
          // console.log(res.data);
          if (res.data.status) {
            self.statusSendingReports = true;
            self.isTrueSendingReports = true;
            self.isFalseSendingReports = false;
          }
          if (!res.data.status || res.data.status === undefined) {
            self.statusSendingReports = false;
            self.isTrueSendingReports = false;
            self.isFalseSendingReports = true;
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    // Obtiene de la base de datos el nombre y correo de todos los tutores
    getInfOfAllTutors() {
      this.showSetEmail = true;
      var payload = {
        width: '500',
        prefixWidth: 'px',
        height: '',
        prefixHeight: '',
      };
      this.$store.commit('SET_STYLE_MODAL', payload);
    },
    go(url) {
      this.$router.push(url);
    },
    toggleWorksheets() {
      if (!this.showWorksheets) {
        var payload = {
          width: '90',
          prefixWidth: 'vw',
          height: '90',
          prefixHeight: 'vh',
        };
        this.$store.commit('SET_STYLE_MODAL', payload);
      }
      this.showWorksheets = !this.showWorksheets;
    },
    closeModalEmail() {
      this.showSetEmail = false;
      this.emailSelected = '';
      this.nameOfTutor = '';
    },
    fetchGrades() {
      this.$store.commit('app/START_PROCESSING');
      this.$httpMain
        .get(`get_id_name_path_all_grade`)
        .then(res => {
          this.grades = res.data;
          console.log(res.data);
        })
        .finally(() => {
          this.$store.commit('app/STOP_PROCESSING');
        });
    },
    // getAllGrades() {
    //   this.$httpMain
    //     .post(`get_id_name_path_all_grade`, {
    //       token: this.$store.state.cookie,
    //     })
    //     .then(res => {
    //       this.grades = res.data;
    //     });
    // },
    handleChangeGrades(e) {
      this.subjects = [];
      this.gradePathSelected = '';
      this.enableSubjects = false;
      this.subjectIdSelected = '';
      this.clusterWorksheets = null;
      this.worksheets = [];
      if (e.target.options.selectedIndex > -1) {
        this.gradePathSelected = e.target.options[e.target.options.selectedIndex].dataset.gradepath;
      }
      this.getContentOfGradeSelected();
      this.enableSubjects = true;
    },
    getContentOfGradeSelected() {
      this.$httpMain
        .post(`get_content_of_grade_selected_grades`, {
          path: this.gradePathSelected,
          token: this.$store.state.cookie,
        })
        .then(res => {
          this.gradeSelected = res.data;
          this.subjects = this.gradeSelected.subjects;
        });
    },
    getWorksheets(e) {
      if (e.target.options.selectedIndex > -1) {
        this.subjectIdSelected = e.target.options[e.target.options.selectedIndex].dataset.subjectid;
        this.getContentOfSubjectSelected();
      }
    },
    getContentOfSubjectSelected() {
      this.$httpMain
        .post(`get_content_of_subject_selected`, {
          course_id: this.subjectIdSelected,
          token: this.$store.state.cookie,
          lang: this.getLanguage,
        })
        .then(res => {
          this.clusterWorksheets = res.data.clusterWorksheets;
          this.getWorksheetLinks();
        });
    },
    UrlExists(url) {
      var http = new XMLHttpRequest();
      http.open('HEAD', url, false);
      http.send();
      return http.status !== 404;
    },
    stopWorksheetProcess(i, ii, iii, iiii) {
      if (i === ii + 1 && iii === iiii + 1) {
        this.$store.commit('STOP_PROCESSING');
      }
    },
    getWorksheetLinks() {
      this.$store.commit('START_PROCESSING');
      var vm = this;
      vm.worksheets = [];
      axios.defaults.baseURL = '';
      this.clusterWorksheets.map((cluster, i) => {
        vm.worksheets.push({ name: cluster.name, lessons: null });
        var lessonsData = [];
        cluster.lessonWorksheets.map((lesson, ii) => {
          var lessonData = {};
          lessonData.name = lesson.name;
          axios
            .head(vm.worksheetPath + lesson.id + '.pdf', {})
            .then(function () {
              lessonData.id = lesson.id;
              lessonData.questions = vm.worksheetPath + lesson.id + '.pdf';
              axios
                .head(vm.worksheetPath + lesson.id + '_answer.pdf', {})
                .then(function () {
                  lessonData.answers = vm.worksheetPath + lesson.id + '_answer.pdf';
                  lessonsData.push(lessonData);
                  vm.worksheets[i].lessons = lessonsData;
                  vm.stopWorksheetProcess(vm.clusterWorksheets.length, i, cluster.lessonWorksheets.length, ii);
                })
                .catch(function (error) {
                  if (error) {
                    lessonData.answers = false;
                    lessonsData.push(lessonData);
                    vm.worksheets[i].lessons = lessonsData;
                    vm.stopWorksheetProcess(vm.clusterWorksheets.length, i, cluster.lessonWorksheets.length, ii);
                  }
                });
            })
            .catch(function (error) {
              if (error) {
                axios
                  .head(vm.worksheetPath + lesson.id + '_1.pdf', {})
                  .then(function () {
                    lessonData.id = lesson.id + '_1';
                    lessonData.questions = vm.worksheetPath + lesson.id + '_1.pdf';
                    axios
                      .head(vm.worksheetPath + lesson.id + '_1_answer.pdf', {})
                      .then(function () {
                        lessonData.answers = vm.worksheetPath + lesson.id + '_1_answer.pdf';
                        lessonsData.push(lessonData);
                        var newLessonData = {};
                        newLessonData.name = lesson.name;
                        newLessonData.id = lesson.id + '_2';
                        newLessonData.questions = vm.worksheetPath + lesson.id + '_2.pdf';
                        axios
                          .head(vm.worksheetPath + lesson.id + '_2_answer.pdf', {})
                          .then(function () {
                            newLessonData.answers = vm.worksheetPath + lesson.id + '_2_answer.pdf';
                            lessonsData.push(newLessonData);
                            vm.worksheets[i].lessons = lessonsData;
                            vm.worksheets.map(cluster => {
                              cluster.lessons.sort(function (a, b) {
                                if (a.id < b.id) return -1;
                                if (a.id > b.id) return 1;
                                return 0;
                              });
                            });
                            vm.stopWorksheetProcess(
                              vm.clusterWorksheets.length,
                              i,
                              cluster.lessonWorksheets.length,
                              ii,
                            );
                          })
                          .catch(function (error) {
                            if (error) {
                              newLessonData.answers = false;
                              lessonsData.push(newLessonData);
                              vm.worksheets[i].lessons = lessonsData;
                              vm.stopWorksheetProcess(
                                vm.clusterWorksheets.length,
                                i,
                                cluster.lessonWorksheets.length,
                                ii,
                              );
                            }
                          });
                      })
                      .catch(function (error) {
                        if (error) {
                          lessonData.answers = false;
                          lessonsData.push(lessonData);
                          var newLessonData = {};
                          newLessonData.name = lesson.name;
                          newLessonData.id = lesson.id + '_2';
                          newLessonData.questions = vm.worksheetPath + lesson.id + '_2.pdf';
                          axios
                            .head(vm.worksheetPath + lesson.id + '_2_answer.pdf', {})
                            .then(function () {
                              newLessonData.answers = vm.worksheetPath + lesson.id + '_2_answer.pdf';
                              lessonsData.push(newLessonData);
                              vm.worksheets[i].lessons = lessonsData;
                              vm.stopWorksheetProcess(
                                vm.clusterWorksheets.length,
                                i,
                                cluster.lessonWorksheets.length,
                                ii,
                              );
                            })
                            .catch(function (error) {
                              if (error) {
                                newLessonData.answers = false;
                                lessonsData.push(newLessonData);
                                vm.worksheets[i].lessons = lessonsData;
                                vm.stopWorksheetProcess(
                                  vm.clusterWorksheets.length,
                                  i,
                                  cluster.lessonWorksheets.length,
                                  ii,
                                );
                              }
                            });
                        }
                      });
                  })
                  .catch(function (error) {
                    if (error) {
                      lessonData.id = lesson.id;
                      lessonData.questions = false;
                      lessonData.answers = false;
                      lessonsData.push(lessonData);
                      vm.worksheets[i].lessons = lessonsData;
                      vm.stopWorksheetProcess(vm.clusterWorksheets.length, i, cluster.lessonWorksheets.length, ii);
                    }
                  });
              }
            });
        });
      });
    },
  },
};
</script>
<style lang="scss" scoped>

/*
   TOC:
  =======

  1. Primary Styles

  2. Custom Utility Classes

  3. Custom Styles

===================================================== */

/* --------------------------------- */
/* 1. Primary Styles
 ----------------------------------- */
/*-- ------ not delete start ------ --*/
i {
  margin-right: 0.5rem;
}
a:link {
  text-decoration: none;
}
/*-- ------ #not delete end ------ --*/
/* --------------------------------- */
/* 2. Custom Utility Classes
 ----------------------------------- */
.setting {
  user-select: none;
  position: relative;
  top: 80px;
  height: 100%;
  width: 100%;
  min-height: min-content;
  padding: 15px 15px;
  margin: 0 auto;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}
.setting-item {
  width: 100%;
  max-width: 100%;
  border-radius: 10px;
  // height: 115px;
  height: 135px;
  margin: 0 auto;
  box-shadow: 5px 5px 10px rgba($color: #000000, $alpha: 0.5);
  display: flex;
  background-color: #ededed;
  position: relative;
  max-width: 950px;
}
.setting-item ~ .setting-item {
  margin-top: 1%;
}
.effect:hover {
  cursor: pointer;
  // box-shadow: 0 0.8rem 2rem 0 rgba(46,46,46,0.067);
  box-shadow: 5px 5px 10px rgba($color: #000000, $alpha: 0.8);
  // margin-top: 13px;
  // // margin-bottom: 20px;
  // transition: margin .1s, box-shadow .1s;
  // transition-timing-function: ease-out;
}
.setting-item-title {
  min-width: 250px;
  max-width: 250px;
  background-color: #c389e5;
  border-radius: 10px;
  box-shadow: 5px 5px 10px rgba($color: #000000, $alpha: 0.5);
  padding: 10px;
  position: relative;
}
.setting-item-title .title {
  color: #fff;
  text-align: center;
  font-family: 'comfortaabold';
  // line-height: 1;
  // font-size: 25px;
}
.setting-item-title img {
  width: 60px;
  height: 55px;
  position: absolute;
  bottom: 30px;
  left: calc(50% - 30px);
}
.setting-item-content {
  padding: 10px 15px;
  font-family: 'comfortaabold';
  position: relative;
  width: 100%;
}
.go-setting {
  font-family: 'comfortaabold';
  position: absolute;
  right: 15px;
  bottom: 10px;
}
.description {
  // font-size: 22px;
  line-height: 1.5;
  // padding: 5px 15px;
  // color: #707070;
  // text-align: justify;
  // line-height: 1.6;
  // height: 50%;
}
.active {
  background-color: #4caf50 !important;
  border-color: #4caf50 !important;
  color: white !important;
}
.disable {
  background-color: #f44336 !important;
  border-color: #f44336 !important;
  color: white !important;
}
.btn.btn-primary.lbl-custom {
  color: black;
  background-color: #ffffff;
  // border-color: #007bff;
  border: 1px solid rgba(0, 0, 0, 0.15);
}
.options {
  display: flex;
  justify-content: flex-end;
  .button{
    cursor: pointer;
    padding: 1rem;
    border-radius: 30px;
    box-shadow: 5px 8px 7px -9px rgba(0,0,0,0.75);
    text-align: center;
  }
  .cancel{
    border: 1px solid #f44336;
    margin-right: 10px;
    color: #f44336;
    min-width: 110px;
    &:hover{
      border: unset;
      background-color: rgba($color: #f44336, $alpha: 0.2);
    }
  }
  .save{
    border: 1px solid #4caf50;
    color: #4caf50;
    min-width: 80px;
    &:hover{
      border: unset;
      background-color: rgba($color: #4caf50, $alpha: 0.2);
    }
  }
}
.options button {
  margin-left: 0.5rem;
}
/* --------------------------------- */
/* 3. Custom Styles
 ----------------------------------- */

/*customizing boostrap*/
.modal-content {
  border-radius: 10px !important;
}
.modal-header {
  background-color: #55c5cc;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  padding: 10px 15px !important;
  h5 {
    font-family: 'comfortaabold';
  }
  .close {
    margin-left: 0;
  }
}
.modal-title.worksheets {
  text-align: center;
  margin: auto;
}
.modal-body-custom {
  padding: 1.5rem 1rem;
}
.close {
  position: relative;
  margin-right: 0;
  background-color: transparent !important;
  cursor: pointer;
}
.btn.btn-primary.lbl-custom {
  height: 1.5rem;
  line-height: 0.4rem;
}
.btn-group {
  float: right;
  margin: 0;
}
.btn-light {
  background-color: #b0d529;
  color: #fff;
}
.btn-light:hover {
  color: #fff;
  background-color: rgba($color: #000000, $alpha: 0.5);
}
/*Vue transition*/
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateX(10px);
  opacity: 0;
}
::-webkit-scrollbar {
  width: 8px;
  border-radius: 0 0 10px 10px;
  background: rgba($color: #ebebeb, $alpha: 0.4);
}
::-webkit-scrollbar-thumb {
  border-radius: 0 0 10px 10px;
  background: #aeaeae;
}
.vue-js-switch {
  min-width: 95px;
}
.vue-js-switch#changed-font {
  font-size: 50px;
}
.select-container {
  position: relative;
  select {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    cursor: pointer;
  }
  img {
    position: absolute;
    margin: auto;
    right: 10px;
    width: 10px;
    top: 0;
    bottom: 0;
    pointer-events: none;
  }
}
.btn {
  font-family: 'comfortaabold';
}
.show-intro-container {
  margin: 2% auto 0;
  width: 950px;
  .show-intro {
    font-family: 'comfortaabold';
    display: inline-block;
    padding: 10px 15px;
    color: #fff;
    background-color: #c389e5;
    border-radius: 15px;
    box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.5);
    label {
      margin-bottom: 0;
      & + label {
        float: right;
        margin-right: 10px;
      }
    }
  }
}
.my-class {
  display: flex;
  justify-content: space-between;
  align-items: center;
 
  background-color: #3960A5;
  img{
    width: 50px;
    cursor: pointer;
  }
  h5{
    font-family: "FuturaBold", Helvetica, Arial;
    font-size: 1.5rem;
    color: white;
  }
  /*button {
    position: absolute;
    right: -20px;
    top: -5px;
    opacity: 1;
    &:hover {
      opacity: 1;
    }
    img {
      width: 40px;
    }
  }*/
}
.worksheet-modal-body {
  height: 90%;
  select {
    color: #ff811c;
    font-size: 20px;
    &:focus {
      color: #ff811c;
      outline: none;
    }
    option {
      color: #000;
      font-size: 16px;
    }
  }
  .worksheets {
    height: 60vh;
    overflow: hidden;
    overflow-y: auto;
  }
  .cluster-worksheet {
    margin-top: 20px;
    padding-right: 20px;
    h4 {
      color: #d71358;
      font-size: 30px;
    }
    .lesson-headings {
      font-weight: bold;
      font-size: 20px;
      // @media (max-width: 576px) {
      //   font-size: 12px;
      // }
    }
    .lesson-worksheet {
      margin-top: 10px;
      span.id {
        color: #99af20;
        font-weight: bold;
      }
      span.worksheet,
      span.answers {
        // display: flex;
        // align-items: center;
        // justify-content: center;
        color: #037cff;
        cursor: pointer;
        // img {
        //   height: 16px;
        //   margin-right: 5px;
        //   margin-top: -8px;
        // }
        a {
          &:hover {
            text-decoration: underline;
          }
        }
      }
      span.na {
        color: #666;
        &:hover {
          text-decoration: none;
          cursor: unset;
        }
      }
    }
    .lesson-headings,
    .lesson-worksheet {
      display: flex;
      justify-content: space-between;
      span.lesson {
        flex-grow: 3;
        flex-basis: 0;
        text-align: left;
      }
      span.id,
      span.worksheet,
      span.answers {
        flex-grow: 1;
        flex-basis: 0;
        text-align: center;
        a {
          margin-bottom: 3px;
          display: block;
        }
      }
    }
  }
}
@media (max-width: 576px) {
  .worksheets {
    width: fit-content;
  }
  .worksheet-modal-body {
    .cluster-worksheet {
      .lesson-headings {
        font-size: 15px;
        width: 400px;
      }
      h4 {
        font-size: 25px;
      }
    }
  }

  .setting-item {
    height: 300px;
    display: block;
    margin-bottom: 20px;
  }
  .setting-item-title {
    width: 100%;
    height: 100px;
    padding: 5px;
    display: flex;
    align-items: center;
    min-width: unset;
    max-width: unset;
  }
  .setting-item-title .title {
    position: relative;
    left: calc(25% - 20px);
    font-size: 14pt;
  }
  .title2 {
    width: 50%;
  }
  .setting-item-title img {
    position: sticky;
    left: calc(70% - 20px);
    height: 65px;
    width: 70px;
  }
  .setting-item-content {
    padding: 10px;
  }
}
@media (min-width: 577px) and (max-width: 768px) {
  //tablet
  .setting-item {
    height: 235px;
    margin-bottom: 20px;
  }

  .setting-item-title .title {
    position: relative;
    font-size: 14pt;
    top: 50px;
  }
  .setting-item-title img {
    position: absolute;
    height: 65px;
    width: 70px;
    bottom: 50px;
  }
}
@media (max-width: 1026px) {
  .worksheet-modal-header button img {
    margin-right: 25px;
    margin-top: 25px;
  }
  .modal-content {
    height: 350px !important;
    overflow-y: scroll;
    max-height: 350px !important;
  }
  .setting {
    height: auto !important;
  }
}
@media (min-width: 1027px) {
  .worksheet-modal-header button img {
    margin-right: 25px;
    margin-top: 25px;
  }
  .modal-content {
    height: 350px !important;
    overflow-y: scroll;
    max-height: 350px !important;
  }
  .setting {
    height: auto !important;
  }
}
</style>
